import {
  Component,
  OnInit,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { NgbModal, NgbModalRef, NgbModule } from "@ng-bootstrap/ng-bootstrap";
// Services
import { TiposEspecialistaService } from "src/app/core/services/tipo-especialista.service";
import { EspecialidadesService } from "src/app/core/services/especialidades.service";
import { EspecialistaService } from "src/app/core/services/especialista.service";
import { HistoriaClinicaService } from "src/app/core/services/historia-clinica.service";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { SedeService } from "src/app/core/services/sede.service";
import { PacientesService } from "src/app/core/services/paciente.service";
import { ConvenioService } from "src/app/core/services/convenio.service";
import { EspecialistaTarifaService } from "src/app/core/services/especialista-tarifa.service";
import { CitaService } from "src/app/core/services/cita.service";
// Models
import { Especialista } from "src/app/core/models";
// Components
import { CalendarioComponent } from "../calendario/calendario.component";
import { CommonModule } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { SharedModule } from "src/app/shared/shared.module";
import { ExpandableTextNewComponent } from "./expandible-new.component";
import { AgendaEspecialistaComponent } from "../agenda-especialista/agenda-especialista.component";

@Component({
  standalone: true,
  selector: "app-citas-list-new",
  templateUrl: "./citas-list-new.componentv2.html",
  styleUrl: "../../../app.component.scss",

  imports: [
    CommonModule,
    NgSelectModule,
    NgbModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ExpandableTextNewComponent,
    AgendaEspecialistaComponent,
  ],
})
export class CitasListNewComponent implements OnInit, OnDestroy {
  @ViewChild("showSchedule") modalProgramar!: TemplateRef<any>;
  @ViewChild("specialistModal") specialistModal!: TemplateRef<any>;

  idPaciente: string = "";
  private routeSub: Subscription = new Subscription();
  datosPaciente: any;
  pacienteAntiguo: boolean = false;
  especialistaSeleccionado: any;

  // Variables de especialistas
  especialistasFiltrados: any[] = [];
  tiposEspecialistas = [];
  especialidades = [];
  idEspecialista: string;
  especialistas: Especialista[] = [];
  hayMasEspecialistas = true;
  convenios = [];
  servicios = [];
  sedes = [];
  formData: FormGroup = new FormGroup({});
  spinner: Boolean = true;

  // Filtros
  searchTipoEspecialista: string = "";
  searchServicio: string = "";
  searchEspecialidad: string = "";
  searchSede: string = "";
  nombreEspecialista: string = "";

  // Variables de estado
  citasPendientesDePago = false;
  unicoEspecialista: Boolean = true;
  cargandoEspecialistas: boolean = false;

  // Variable para mostrar/ocultar convenios
  mostrarConvenios: boolean = false;

  //Variables para consultar la agenda del especialista
  idUsuarioAsigna: string;
  tUsuarioAsigna: string;
  nombreUsuarioAsigna: string;

  filtroEspecialista: string = "";
  filtroEspecialistaTraidos: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private __citaService: CitaService,
    public __historiasClinicasService: HistoriaClinicaService,
    private __sedeService: SedeService,
    private formBuilder: UntypedFormBuilder,
    private __convenioService: ConvenioService,
    private __pacientesService: PacientesService,
    private __serviciosService: ServiciosService,
    private __especialistasService: EspecialistaService,
    private __especialidadesService: EspecialidadesService,
    private __tiposEspecialistaService: TiposEspecialistaService,
    private __especialistaTarifaService: EspecialistaTarifaService,
    public router: Router,
  ) {}

  /**
   * Método que se ejecuta al inicializar el componente
   * Configura la suscripción a los parámetros de la ruta para obtener el ID del paciente
   */
  ngOnInit(): void {
    // Obtener datos COMPLETOS del usuario desde la sesión
    const userSession = JSON.parse(
      localStorage.getItem("currentPatient") || "{}",
    );
    //console.log('Datos completos de sesión:', userSession);

    // Si tenemos paciente en la sesión
    if (userSession && userSession.userId && userSession.role === "PACIENTE") {
      // Usar datos directamente de la sesión
      this.idUsuarioAsigna = userSession.userId;
      this.tUsuarioAsigna = userSession.role;
      this.nombreUsuarioAsigna = userSession.nombre;
      this.idPaciente = userSession.userId;

      // Establecer datosPaciente con los datos de la sesión
      this.datosPaciente = {
        ...userSession,
        $id: userSession.userId,
        pais: userSession.pais || "CO",
        idEmpresa: userSession.idEmpresa || null,
      };

      // Cargar convenios si tiene empresa
      if (this.datosPaciente.idEmpresa) {
        const idEmpresa =
          this.datosPaciente.idEmpresa.$id || this.datosPaciente.idEmpresa;
        this.cargarConvenios(idEmpresa);
      }

      // AQUÍ ES LA CORRECCIÓN: También verificar si tiene historial con algún especialista
      this.verificarUltimoEspecialista(this.idPaciente);
    } else {
      // No hay paciente en sesión, mostrar especialistas sin contexto
      //console.log('No hay paciente en sesión');
      this.getEspecialistas();
    }
  }

  /**
   * Verifica si el paciente tiene historial previo con algún especialista
   * Este método se ejecuta tanto para pacientes de sesión como de parámetros de ruta
   */
  private async verificarUltimoEspecialista(idPaciente: string): Promise<void> {
    try {
      // Busca la última historia clínica del paciente
      const historiasClinicas =
        await this.__historiasClinicasService.getHistoriasClinicasPacienteLast(
          idPaciente,
        );

      if (historiasClinicas && historiasClinicas.length >= 1) {
        //console.log('Paciente tiene historial previo, mostrando último especialista');
        // Si tiene historias clínicas previas, muestra solo ese especialista
        this.unicoEspecialista = true;
        this.idEspecialista = historiasClinicas[0].idEspecialista["$id"];

        const especialistaResponse =
          await this.__especialistasService.getEspecialistaOneBasico(
            this.idEspecialista,
          );

        if (especialistaResponse && especialistaResponse.length > 0) {
          this.especialistas = especialistaResponse;
          this.especialistasFiltrados = especialistaResponse;
          this.filtroEspecialistaTraidos = especialistaResponse;
          this.spinner = false;
        } else {
          // El especialista del historial está inactivo, mostrar todos los activos
          this.unicoEspecialista = false;
          this.idEspecialista = undefined;
          this.getEspecialistas();
        }
      } else {
        //console.log('Paciente sin historial previo, mostrando todos los especialistas');
        // Si no tiene historias previas, muestra todos los especialistas disponibles
        this.unicoEspecialista = false;
        this.getEspecialistas();
      }
    } catch (error) {
      //console.error('Error verificando último especialista:', error);
      // En caso de error, mostrar todos los especialistas
      this.unicoEspecialista = false;
      this.getEspecialistas();
    }
  }

  private cargarConvenios(idEmpresa: string): void {
    this.__convenioService
      .getConveniosEmpresaActive(idEmpresa)
      .then((convenios: any) => {
        this.convenios = convenios;
      })
      .catch((error) => {
        console.error("Error cargando convenios:", error);
      });
  }

  /**
 * Método de inicialización cuando ya tenemos datos del paciente de la sesión
 
  private iniciaConDatosDeSesion(): void {
    console.log('Iniciando con datos del paciente desde la sesión');
    
    // Solo mostrar todos los especialistas disponibles sin restricciones
    // ya que el paciente viene de la sesión y puede elegir cualquier especialista
    this.unicoEspecialista = false;
    this.getEspecialistas();
  }*/

  /**
   * Método que se ejecuta al destruir el componente
   * Limpia las suscripciones para evitar memory leaks
   */
  ngOnDestroy(): void {
    this.routeSub.unsubscribe();
  }

  /**
   * Obtiene la lista de especialistas disponibles
   * Utiliza el ID del especialista actual si existe, sino obtiene todos
   */
  getEspecialistas(): void {
    this.__especialistasService
      .getEspecialistasBasico(this.idEspecialista)
      .then((response: Especialista[]) => {
        // console.log('especialistas: ', response);
        this.especialistas = response;
        this.especialistasFiltrados = response;
        this.filtroEspecialistaTraidos = response;

        this.spinner = false; // Oculta el indicador de carga
        this.hayMasEspecialistas = false; // Indica que ya se cargaron todos
        this.spinner = false;
        this.hayMasEspecialistas = false;
      })
      .catch(() => {
        this.spinner = false;
        this.hayMasEspecialistas = false;
      });
  }

  /**
   * Método para recargar todos los especialistas disponibles
   * Se ejecuta cuando el usuario solicita ver más especialistas
   */
  onTraerTodosEspecialistas(): void {
    this.getEspecialistas();
  }

  filtrarEspecialistas(): void {
    if (!this.nombreEspecialista || this.nombreEspecialista.trim() === "") {
      // Si no hay búsqueda, mostrar todos
      this.especialistasFiltrados = this.especialistas;
    } else {
      // Filtrar por nombre
      const busqueda = this.nombreEspecialista.toLowerCase();
      this.especialistasFiltrados = this.especialistas.filter((esp) =>
        esp.nombre.toLowerCase().includes(busqueda),
      );
    }
  }

  /**
   * Getter para acceder fácilmente a los controles del formulario
   * @returns Los controles del formulario reactivo
   */
  get form() {
    return this.formData.controls;
  }

  // #############################################################################################
  // Filtrar paciente

  /*
  filtrarEspecialistas(): void {
    console.log("Primer especialista:", this.especialistasFiltrados[0]); // Ver estructura

    if (!this.filtroEspecialista.trim()) {
      console.log("No hay filtro");
      this.filtroEspecialistaTraidos = this.especialistasFiltrados;
    } else {
      console.log("Si hay filtro");
      console.log(this.especialistasFiltrados);
      this.filtroEspecialistaTraidos = this.especialistasFiltrados.filter(
        (especialista) =>
          especialista.nombre
            .toLowerCase()
            .includes(this.filtroEspecialista.toLowerCase())
      );
    }
  }*/
}
